export enum EngineType {
    Extraction = 'extraction',
    Aigcd = 'aigcd',
    Compression = 'compression',
    Coo = 'coo',
    Dlp = 'dlp',
    Cdr = 'cdr',
    Filetype = 'filetype',
    Filescanio = 'filescanio',
    Oesis = 'oesis',
    Sbom = 'sbom',
    Metascan = 'metascan',
    Allowlist = 'allowlist',
    Blocklist = 'blocklist',
    General = 'general',
}

export enum GateId {
    Zero = 0,
    One = 1,
    Two = 2,
    Three = 3,
}

export enum AVResult {
    Clean = 'clean',
    Infected = 'infected',
    Suspicious = 'suspicious',
    FailedToScan = 'failed_to_scan',
    NotScanned = 'not_scanned',
    PotentiallyUnwanted = 'potentially_unwanted',
}

export enum CDRResult {
    DSBlocked = 'ds_blocked',
    SanitizedOrPartially = 'sanitized_or_partially',
    SanitizationFailedOrTimedout = 'sanitization_failed_or_timedout',
    NotSanitized = 'not_sanitized',
    SanitizationSkipped = 'sanitization_skipped',
}

export enum ScanResultCode {
    NoThreatDetected = 0,
    Infected = 1,
    Suspicious = 2,
    Failed = 3,
    Whitelisted = 7,
    Blacklisted = 8,
    ExceededArchiveDepth = 9,
    NotScanned = 10,
    EncryptedArchive = 12,
    ExceededArchiveSize = 13,
    ExceededArchiveFileNumber = 14,
    PasswordProtectedDocument = 15,
    ExceededArchiveTimeout = 16,
    Mismatch = 17,
    PotentiallyVulnerableFile = 18,
    Cancelled = 19,
    SensitiveDataFound = 20,
    YaraRuleMatched = 21,
    PotentiallyUnwanted = 22,
    UnsupportedFileType = 23,
    ExtractionFailed = 24,
    ScanFailed = 25,
    SuspiciousSandbox = 26,
    LikelyMaliciousSandbox = 27,
    MaliciousSandbox = 28,
    BlockedSandbox = 29,
    BlockedDeepCDR = 30,
    GlobalTimeoutExceeded = 31,
    VulnerableSBOM = 32,
    NonVulnerableSBOM = 33,
    BlockedSBOM = 34,
    WeakVulnerableSBOM = 35,
    BlockedByPostAction = 36,
    KnownBad = 38,
    KnownGood = 39,
    Unknown = 40,
    AllowedCOO = 41,
    BlockedCOO = 42,
    UnknownCOO = 43,
    Exempted = 44,
    CompressionFailed = 45,
    InProgress = 255,
    SkipProcessingFastSymlink = 1014,
}

